import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-block-grid',
  standalone: true,
  imports: [],
  templateUrl: './block-grid.component.html',
  styleUrls: ['./block-grid.component.scss']
})
export class BlockGridComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
